import React, {useState} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useAuth } from '../../contexts/AuthContext';
import ReCAPTCHA from "react-google-recaptcha";
import TextField from '@material-ui/core/TextField'
import green from '@material-ui/core/colors/green';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const EmailTextField = withStyles((theme) => ({
  root: {
    '& > *': {
      marginLeft: 10,
      marginBottom: 10,
      width: '30ch',
    },
  },
}))(TextField);

export default function ResetPasswordDialog() {
  const [open, setOpen] = React.useState(false);
  const [username, setUserName] = useState();
  const [recaptcha, setRecaptcha] = useState("NIL");
  const { resetPassword } = useAuth();
  const site_key = process.env.REACT_APP_RECAPTCHA_SITE_KEY

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    //Verify user
    if (recaptcha !== "NIL") {
      resetPassword(username)
      setRecaptcha("NIL")
      .catch((error) => {
        // const errorCode = error.code;
        // const errorMessage = error.message;
      });
    }
    setOpen(false);
  };

  const onRecaptcha = (value) => {
    setRecaptcha(value)
  }

  return (
    <div>
      <Button color="secondary" onClick={handleClickOpen}>
        Reset Password?
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Reset Password
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            A Reset Password Email will be sent to your Inbox.
          </Typography> 
          <EmailTextField formControlProps={{
              fullWidth: true
            }} 
          id="email" label="email" 
          onChange={e => setUserName(e.target.value)} />
          <ReCAPTCHA
            sitekey={site_key}
            onChange={onRecaptcha}
          />
        </DialogContent> 
        <DialogActions>
          <Button autoFocus onClick={handleClose} color={green[700]}>
            Reset Password
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}